import { SubmitHandlerWithDirtyFields } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { getGetUsersPaginatedDefaultValues } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/users/models/inputs/get-users-paginated.form-default-values';
import { GetUsersPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/users/models/inputs/get-users-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { Logger } from '@app/core/logger/logger';

import {
  FilterSearchUserListContextProvider,
  useUserListContext,
} from '../user.context';
import { UserListFilterSearchFormController } from './user-list-filter-search-form/user-list-filter-search-form.controller';

interface UserListFilterSearchControllerProps {
  onCancel: () => void;
  onSuccess: () => void;
}

export const UserListFilterSearchController = ({
  onCancel,
  onSuccess,
}: UserListFilterSearchControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();
  const { getPaginatedQueryParameters, setGetPaginatedQueryParameters } =
    useUserListContext();

  // HANDLERS //////////////////////////////////////////////////////////////////

  const handleError: SubmitErrorHandler<GetUsersPaginatedModel> = (errors) => {
    Logger.error(errors);
    toast.error(
      t('$.user-list-filter-search.error', { error: t('global.unknown') }),
    );
  };

  const handleSubmit: SubmitHandlerWithDirtyFields<GetUsersPaginatedModel> = (
    fieldValues,
  ) => {
    setGetPaginatedQueryParameters((current) => {
      return {
        ...current,
        textToSearch: fieldValues.textToSearch,
      };
    });
    onSuccess();
  };

  // RENDER ////////////////////////////////////////////////////////////////////

  const data = getGetUsersPaginatedDefaultValues(getPaginatedQueryParameters);

  return (
    <FilterSearchUserListContextProvider data={data}>
      <UserListFilterSearchFormController
        onError={handleError}
        onSubmit={handleSubmit}
        onCancel={onCancel}
      />
    </FilterSearchUserListContextProvider>
  );
};
